module.exports = __webpack_public_path__ + "static/mentor-header-29ee560bb6b5d2c4c23af5ef603cd774.jpg";